import { defineMessages } from 'react-intl';

export default defineMessages({
  proceedPaypal: {
    id: 'widget.payments.proceed-paypal',
    defaultMessage: 'Proceed with PayPal',
  },
  subscriptionMonth: {
    id: 'widget.payments.subscription-month',
    defaultMessage: 'Subscription {price}/month',
  },
  purchase: {
    id: 'widget.payments.purchase',
    defaultMessage: 'Purchase {price}',
  },
  rent: {
    id: 'widget.payments.rent',
    defaultMessage: 'Rent {price}',
  },
  singleVideoStreaming: {
    id: 'widget.payments.single-video-streaming',
    defaultMessage: '1 video streaming',
  },
  streamingPeriod: {
    id: 'widget.payments.streaming-period',
    defaultMessage: '{period} hours streaming period starts when you hit the "play" button',
  },
  singleVideo: {
    id: 'widget.payments.single-video',
    defaultMessage: '1 video',
  },
  onePayment: {
    id: 'widget.payments.one-payment',
    defaultMessage: 'One time payment',
  },
  unlimitedStreaming: {
    id: 'widget.payments.unlimitedStreaming',
    defaultMessage: 'Unlimited streaming',
  },
  instantAccess: {
    id: 'widget.payments.instant-access',
    defaultMessage: 'Instant access to new videos',
  },
  monthlyPayment: {
    id: 'widget.payments.monthly-payment',
    defaultMessage: 'Recurring monthly payment (you can cancel this anytime)',
  },
  subscribeToChannel: {
    id: 'widget.payments.subscribe-to-channel',
    defaultMessage: 'Subscribe to channel',
  },
  cancelSubscription: {
    id: 'widget.payments.cancel-subscription',
    defaultMessage: 'Cancel subscription',
  },
  subscribedSince: {
    id: 'widget.payments.subscribed-since',
    defaultMessage: 'Subscribed since {date}. {price}/month',
  },
  memberOnlyBenefits: {
    id: 'widget.payments.member-only-benefits',
    defaultMessage: 'Here\'s what you\'ll get:',
  },
});



// WEBPACK FOOTER //
// ./src/widget/components/payments/translations.js